export const CONTEST_CATEGORIES = [
  { id: 'all', label: 'All Contests' },
  { id: 'skills', label: 'Skills' },
  { id: 'drills', label: 'Drills' },
  { id: 'fitness', label: 'Fitness' },
  { id: 'fun-format', label: 'Fun Format' },
  { id: 'creative-format', label: 'Creative Format' },
] as const;

export type ContestCategoryId = (typeof CONTEST_CATEGORIES)[number]['id'];
export type ContestView = 'browse' | 'submissions' | 'leaderboard';

export const CONTEST_VIEWS: { id: ContestView; label: string }[] = [
  { id: 'browse', label: 'Browse Contests' },
  { id: 'submissions', label: 'My Submissions' },
  { id: 'leaderboard', label: 'Leaderboard' },
];

export const CONTEST_REGISTRATION_TEXT = 'Registration Fee: INR 500';
export const CONTEST_PRIZE_TEXT = '1st Prize: INR 5,000 | 2nd Prize: INR 2,000 across all categories';
export const CONTEST_PARTICIPANT_GROUPS = [
  'Individual players',
  'Academies',
  'Schools',
  'Corporate teams',
  'Clubs and organizations',
];

export const getContestCategoryLabel = (categoryId: string) =>
  CONTEST_CATEGORIES.find((c) => c.id === categoryId)?.label || categoryId;

export interface ContestTaskLike {
  title?: string;
  description?: string;
  participationFormat?: string;
  targetItems?: { type?: string }[];
}

export const getContestTaskCategory = (task: ContestTaskLike): ContestCategoryId => {
  const format = String(task.participationFormat || '').toLowerCase();
  const combined = `${task.title || ''} ${task.description || ''} ${format}`.toLowerCase();

  if (combined.includes('creative format') || format.includes('creative')) return 'creative-format';
  if (combined.includes('fun format') || format.includes('fun format') || format === 'fun') return 'fun-format';

  const types = new Set((task.targetItems || []).map((item) => String(item.type || '').toLowerCase()));
  if (types.has('fitness')) return 'fitness';
  if (types.has('drill')) return 'drills';
  if (types.has('skill')) return 'skills';

  if (format.includes('fitness')) return 'fitness';
  if (format.includes('drill')) return 'drills';
  if (format.includes('skill')) return 'skills';
  if (format.includes('creative')) return 'creative-format';
  if (format.includes('fun')) return 'fun-format';

  return 'skills';
};

export const matchesContestTaskCategory = (task: ContestTaskLike, categoryId: string): boolean => {
  if (!categoryId || categoryId === 'all') return true;
  return getContestTaskCategory(task) === categoryId;
};
